import { AxiosClient } from "@/app/shared/services";
import triggersService from "./shared/services/triggersService";

const state = {
    list: {
        triggers: [],
        isLoading: false,
        filters: {},
    },
    update: {
        trigger: {},
        isLoading: false,
    },
};

const getters = {
    TRIGGERS_LIST: (state) => state.list.triggers,
    TRIGGERS_LIST_LOADING: (state) => state.list.isLoading,
    CURRENT_TRIGGER: (state) => state.update.trigger,
    UPDATE_TRIGGER_LOADING: (state) => state.update.isLoading,
};

const mutations = {
    SET_TRIGGERS_LIST_LOADING: (state, isLoading) => {
        state.list.isLoading = isLoading;
    },
    SET_TRIGGERS_LIST: (state, list) => {
        state.list.triggers = list;
    },
    SET_UPDATE_TRIGGER_LOADING: (state, isLoading) => {
        state.update.isLoading = isLoading;
    },
    SET_CURRENT_TRIGGER: (state, trigger) => {
        state.update.trigger = trigger;
    },
};

const actions = {
    FETCH_TRIGGERS: (context, filters) => {
        context.commit("SET_TRIGGERS_LIST_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/triggers/get", { params: filters })
                .then((response) => {
                    const triggers = triggersService.parseTriggerList(response.data);
                    context.commit("SET_TRIGGERS_LIST", triggers);
                    resolve(response.data);
                })
                .catch(() => reject())
                .finally(() => context.commit("SET_TRIGGERS_LIST_LOADING", false));
        });
    },
    FETCH_TRIGGER: (context, id) => {
        context.commit("SET_UPDATE_TRIGGER_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/triggers/${id}`)
                .then((response) => {
                    const trigger = response.data;
                    context.commit("SET_CURRENT_TRIGGER", trigger);
                    resolve(trigger);
                })
                .catch(() => reject())
                .finally(() => context.commit("SET_UPDATE_TRIGGER_LOADING", false));
        });
    },
    UPDATE_TRIGGER: (context, trigger) => {
        context.commit("SET_UPDATE_TRIGGER_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/triggers/update/${trigger.id}`, trigger)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => context.commit("SET_UPDATE_TRIGGER_LOADING", false));
        });
    },
    CREATE_TRIGGER: (context, params) => {
        context.commit("SET_UPDATE_TRIGGER_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post("/triggers/create", params)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => context.commit("SET_UPDATE_TRIGGER_LOADING", false));
        });
    },

    DELETE_TRIGGER: (context, trigger) => {
        context.commit("SET_TRIGGERS_LIST_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/triggers/delete/${trigger.id}`)
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => context.commit("SET_TRIGGERS_LIST_LOADING", false));
        });
    },

    SWITCH_TRIGGER: (context, { trigger, isEnabled }) => {
        context.commit("SET_TRIGGERS_LIST_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/triggers/switch/${trigger.id}`, { enabled: isEnabled })
                .then((response) => resolve(response.data))
                .catch(() => reject())
                .finally(() => context.commit("SET_TRIGGERS_LIST_LOADING", false));
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
